import Errors from "@shared/errors";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const initialState = () => {
    return {
        paymentStatus: "",
        planStatus: "",
        planCart: { p_name: "", p_price: 0.0 },
        plans: [],
        plansCount: 0,
        planErrors: new Errors(),
        paymentErrors: new Errors(),
    };
};

const state = {
    initialState: initialState,
    ...initialState(),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
